import React, { useRef, useEffect } from 'react'
import cssLessonGoals from './LessonGoals.module.scss'
// import GoogleShareToClassRoom from '../../../Utils/GShare.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "LessonGoals"
// #endregion Constant

// #region Enumeration
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mstrLUCatSeqNo = ""
// #endregion Member Variables

function LessonGoals(props)
{
    console.log(COMP_NAME + ".Begin:", props)

    // #region Init State
    // #endregion Init State

    // #region Init Ref
    let mrefGoalsDetailList = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
      
        mrefPaintedMe.current()

        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
            mblnInitialized = false
        }
    }, [props.PathName])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")
        RegisterLanguageChangeHandler()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        UnregisterLanguageChangeHandler()
    }
    // #endregion Painted Me

    // #region OnTapHandler

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置
        
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }
    // #endregion Other Handler

    // #region Toast
    // #endregion Toast

    // #region Component Callback
    // #endregion Component Callback

    // #region Other Functions
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion Other Functions

    // #region Get ClassName and Style
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssLessonGoals.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea")

        var strTitleEN = props.SubSectionDef.Name
        var strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName
        }

        return (
            <div className={cssLessonGoals.divTitleLeftArea}>
                {RenderGoogleClassrommButton()}
                <div className={cssLessonGoals.divTitleSubArea}>
                    <div className={cssLessonGoals.divLessonIcon}></div>
                    <div className={cssLessonGoals.divLUTitleTextEN}>
                        {strTitleEN}
                    </div>
                    <div className={cssLessonGoals.divDividerBar}></div>
                    <div className={cssLessonGoals.divLUTitleTextCN}>
                        {strTitleCN}
                    </div>
                </div>
            </div>
        )
    }

    function RenderGoalsTitleArea()
    {
        // console.log(COMP_NAME + ".RenderGoalsTitleArea")
        console.log("window.gSession.App.CurrentLesson.Def.MajorName: ", window.gSession.App.CurrentLesson.Def.MajorName)
        console.log("window.gSession.App.CurrentLesson.Def.MinorName: ", window.gSession.App.CurrentLesson.Def.MinorName)
        let strNameCN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? window.gSession.App.CurrentLesson.Def.MajorName : window.gSession.App.CurrentLesson.Def.MinorName
        return (
            <div className={cssLessonGoals.divGoalsTitleArea}>
                <div className={cssLessonGoals.divGoalsTitle}>
                    <div className={cssLessonGoals.divTitleTextChinese}>
                        {strNameCN}
                    </div>
                    <div className={cssLessonGoals.divTitleTextEnglish}>
                        {window.gSession.App.CurrentLesson.Def.Name}
                    </div>
                </div>
            </div>
        )
    }

    function RenderListArea()
    {
        // console.log(COMP_NAME + ".RenderListArea")

        return (
            <div className={cssLessonGoals.divGoalsListArea}>
                <div ref={mrefGoalsDetailList} className={cssLessonGoals.divGoalsDetailList} >
                    {props.LUInfo.Goals.map((Result, Index) =>
                        <div key={Index} className={cssLessonGoals.divGoalCellArea}>
                            <div className={cssLessonGoals.divGoalDetailIcon}></div>
                            <div className={cssLessonGoals.divGoalDetailText}>
                                {Result.MajorGoal}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    function RenderContentArea()
    {
        // console.log(COMP_NAME + ".RenderContentArea: ")
        return (
            <div className={cssLessonGoals.divContentArea} >
                <div className={cssLessonGoals.divContentTopSpace}></div>
                {RenderGoalsTitleArea()}
                <div className={cssLessonGoals.divContentMiddleSpace}></div>
                {RenderListArea()}
                <div className={cssLessonGoals.divContentBottomSpace}></div>
            </div>
        )
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            {RenderContentArea()}
        </>
    )
    // #endregion Render
}
export default LessonGoals